<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Settings') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/menus/AccountantsSubmenu.vue'

export default {
  name: 'AccountantsSettingsMenu',
  components: { AccountantsSubmenu },
  computed: {
    menuItems() {
      return [
        {
          key: 'company-details',
          label: this.$gettext('Company details'),
          name: 'AccountantCompanySettings',
          icon: 'fa-briefcase',
          analytics: 'settings company details',
        },
        {
          key: 'personal-profile',
          label: this.$gettext('Personal profile'),
          name: 'AccountantProfileSettings',
          analytics: 'settings personal profile',
          icon: 'fa-gear',
        },
        {
          key: 'change-password',
          label: this.$gettext('Change password'),
          name: 'AccountantProfileChangePassword',
          icon: 'fa-lock',
          analytics: 'settings change password',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
